export default {
  afterReturnAddress: '售后收货地址',
  shippingAddressAfter: '售后发货地址',
  selectCountry: '选择国家',
  addAddress: '新增地址',
  editAddress: '编辑地址',
  edit: '编辑',
  delete: '删除',
  confirm: '确认',
  cancel: '取消',
  save: '保存',
  tips: '提示',
  deleteConfirm: '确定要删除该地址吗？',
  county: 'County',
  subcountyTown: 'Subcounty/Town',
  areaWard: 'Area(ward)',
  detailAddress: '详细地址',
  name: '姓名',
  phone: '手机号码',
  isDefault: '是否默认',
  yes: '是',
  no: '否',
  pleaseSelect: '请选择',
  pleaseInput: '请输入',
  pleaseInputName: '请输入姓名',
  pleaseInputPhone: '请输入手机号码',
  pleaseInputDetail: '请输入详细地址',
  pickupPoint: '揽收点',
  select: '选择',
  pleaseSelectKilishop: '请选择揽收点',
  close: '关闭',
  normal: '正常',
  frozen: '冻结',
  nonData: '暂无数据',
  status: '状态',
  location: '区域',
  pleaseInputNames: '请输入名称',
  search: '查询',
  repairEntrustTitle: '平台授权维修代理服务',
  repairEntrustDesc: '平台付费授权维修：商家可指定特定类目与品牌由平台代理维修。若您未开启类目/品牌维修代理，或开启后商品仍不在支持的类目或品牌范围内，全部售后维修工作需由商家自行处理。',
  repairEntrustCategoryTitle: '按类目开启平台维修代理',
  repairEntrustBrandTitle: '按品牌开启平台维修代理',
  repairEntrustCategoryDesc: '勾选此项后，属于平台支持维修类目的商品，将由指定的平台维修服务商承接维修。此为增值付费服务。',
  repairEntrustBrandDesc: '勾选此项后，属于平台支持维修品牌的商品，将由指定的平台维修服务商承接维修。此为增值付费服务。',
  viewFeeStandards: '查看收费标准',
  viewSupportedCategories: '查看支持维修的类目',
  viewSupportedBrands: '查看支持维修的品牌'
}
